(function (){
    'use strict';

    angular
        .module('app')
        .directive('countryRegionCities', countryRegionCity);

    countryRegionCity.$inject = ['CountriesNewService'];

    function countryRegionCity(CountriesNewService) {
       var directive =  {
           restrict:'E',
           scope:{
               citiesSelected:'=items'
           },
           templateUrl: 'templates/directives/country/view/countryRegionCity.html',
           link:link,
           controller:countryRegionCityCtrl,
           controllerAs: 'vm',
           bindToController: true
       };
       return directive;

       function link(scope, element, attrs, ctrl) {
            var countryList     = [];
            var vm = this;
            vm.countrySelected = [];
            vm.regionSelected = [];
        }
    }

    countryRegionCityCtrl.$inject = ['CountriesNewService','$scope', '$compile','$timeout','$filter','$q'];

    function countryRegionCityCtrl(CountriesNewService, $scope, $compile, $timeout, $filter, $q) {
        var vm = this;
            vm.countrySelected   = {};
            vm.countryList       = [];
            vm.regionSelected    = {};
            vm.citiesSelected    = [];
            vm.arrayItems        = [];
            vm.arrayAux          = [];
            vm.regionList        = [];
            vm.citiesList        = [];
            vm.i                 = 0;
            vm.x                 = 0;
            vm.citiesSelectedAux = 0;
            vm.selectCountries   = selectCountries;
            vm.selectRegions     = selectRegions;
            vm.selectCities      = selectCities;
            vm.remove            = remove;
            vm.citySelected      = citySelected;
            vm.loadArraysRegions = loadArraysRegions;
            vm.loadArrays        = loadArrays;
            vm.countrySelect     = countrySelect;

        function activate() {
            console.log('carregou o componente');
            vm.selectCountries();
        }

        function selectCountries () {
            return CountriesNewService.getCountries().then(function(response){
                vm.countryList = response.data;
                console.log(vm.citiesSelected);
                if(typeof vm.citiesSelected !== 'undefined' || vm.citiesSelected.length > 0) {
                    vm.loadArraysRegions(vm.citiesSelected);
                }
            }).catch(function(err) {
            });
        }

        function countrySelect() {
            var country = vm.countrySelected;
            var item = {};
            item.country_name = angular.copy(country.name);
            item.country_id   = angular.copy(country.id);
            item.region_name  = 'all';
            item.region_id    = 'all';
            if(!vm.arrayItems[item.country_id]) {
                vm.arrayItems[item.country_id] = [];
                vm.arrayItems[item.country_id].push(item);
                vm.arrayAux.push(item.country_id);
            } else {
                vm.arrayItems[item.country_id] = item;
            }
            console.log(vm.arrayItems);
            vm.selectRegions();
        }

        function loadArraysRegions(citiesObj) {
            console.log(citiesObj);
            vm.countrySelected.id = citiesObj[vm.i][0].country_id;
            vm.countrySelected.name = citiesObj[vm.i][0].country_name;
            vm.regionSelected.id = citiesObj[vm.i][0].region_id;
            vm.regionSelected.name = citiesObj[vm.i][0].region_name;
            var countryAux = angular.copy({id:vm.countrySelected.id,name:vm.countrySelected.name});
            var regionAux = angular.copy({id:vm.regionSelected.id,name:vm.regionSelected.name});
            if(vm.citiesSelected.length !== []) {
                vm.loadArrays(vm.citiesSelected);
            } else {
                vm.selectCities(countryAux,regionAux);
            }
        }

        function loadArrays(citiesObj) {
                vm.countrySelected.id = angular.copy(citiesObj[vm.i][0].country_id);
                vm.countrySelected.name = angular.copy(citiesObj[vm.i][0].country_name);
                vm.regionSelected.id = angular.copy(citiesObj[vm.i][0].region_id);
                vm.regionSelected.name = angular.copy(citiesObj[vm.i][0].region_name);
                var countryAux = angular.copy({id:vm.countrySelected.id,name:vm.countrySelected.name});
                var regionAux = angular.copy({id:vm.regionSelected.id,name:vm.regionSelected.name});
                vm.selectCities(countryAux,regionAux);
        }

        function selectRegions () {
            CountriesNewService.getRegions(vm.countrySelected.id).then(function(response){
                vm.regionList = response.data;
            }).catch(function(err) {

            });
        }
        function selectCities (country, region, index) {
            country = country ? country : angular.copy(vm.countrySelected);
            region = region ? region : angular.copy(vm.regionSelected);
            index = index ? index : false;
            return CountriesNewService.getCities(country.id, region.id).then(function(response){
                var item = {};
                vm.cities = {};
                item.country_name = country.name;
                item.country_id   = country.id;
                item.region_name  = region.name;
                item.region_id    = region.id;
                vm.cities         = response.data;
                item.cities       = [];
                item.cities = response.data.map(function (value) {
                    value.country_name = item.country_name;
                    value.country_id = item.country_id;
                    value.region_name  = item.region_name;
                    value.region_id  = item.region_id;
                    return value;
                });
                if(index) {
                    console.log(vm.arrayItems[index]);
                    // vm.arrayItems[index].map(function(value){
                    //    // if(value.region_id == 'all' )
                    //
                    // });
                    vm.arrayItems[index].push(item);
                }

                // if(typeof vm.citiesSelected !== 'undefined' || vm.citiesSelected.length > 0) {
                //     if (vm.i < vm.citiesSelected.length) {
                //         vm.i++;
                //         vm.loadArrays(vm.citiesSelected);
                //     }
                // }
            }).catch(function(err) {
                return false;
            });
        }
        function remove(data) {
            vm.arrayItems.splice(vm.arrayItems.indexOf(data), 1);
            vm.citiesSelected.splice(vm.citiesSelected.indexOf(data), 1);
        }

        function citySelected(selectedItem, model) {
        }
        activate();
    }
})();